import React from 'react';

/**
 * Displays the first Product Highlight in the productHighlights list.
 * Nothing will be displayed if the list is empty.
 * 
 * @param productHighlights The list of Gear Product Highlights appropriate for the user
 */
export default function ProductHighlights({ productHighlights }) {
	
	if (productHighlights?.[0]?.html) {
		return <div dangerouslySetInnerHTML={{ __html: productHighlights[0].html }}></div>
	}

	return null;
}
